"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MerklePedersen = void 0;
const micro_starknet_1 = require("micro-starknet");
class MerklePedersen {
    constructor(values) {
        this.root = MerklePedersen.computeMerkleRoot(values);
    }
    static getProof(values, index) {
        return MerklePedersen.getProofHelper(values, index, []);
    }
    static computeMerkleRoot(values) {
        if (values.length == 1) {
            return values[0];
        }
        if (values.length % 2 != 0) {
            values.push('0x0');
        }
        const nextLevel = MerklePedersen.getNextLevel(values);
        return MerklePedersen.computeMerkleRoot(nextLevel);
    }
    static getNextLevel(level) {
        const nextLevel = [];
        for (let i = 0; i < level.length; i += 2) {
            let node = '0x0';
            if (BigInt(level[i]) < BigInt(level[i + 1])) {
                node = (0, micro_starknet_1.pedersen)(level[i], level[i + 1]);
            }
            else {
                node = (0, micro_starknet_1.pedersen)(level[i + 1], level[i]);
            }
            nextLevel.push(node);
        }
        return nextLevel;
    }
    static getProofHelper(level, index, proof) {
        if (level.length == 1) {
            return proof;
        }
        if (level.length % 2 != 0) {
            level.push('0x0');
        }
        const nextLevel = MerklePedersen.getNextLevel(level);
        let indexParent = 0;
        for (let i = 0; i < level.length; i++) {
            if (i == index) {
                indexParent = Math.floor(i / 2);
                if (i % 2 == 0) {
                    proof.push(level[index + 1]);
                }
                else {
                    proof.push(level[index - 1]);
                }
            }
        }
        return MerklePedersen.getProofHelper(nextLevel, indexParent, proof);
    }
}
exports.MerklePedersen = MerklePedersen;
